<script setup>
definePage({
  meta: {
    layout: "blank",
    public: true,
    title: "Page Not Found",
    description: "The page you’re looking for doesn’t exist on NEXUS.",
  },
});
</script>

<template>404 page</template>
